import Player from '@vimeo/player';

const vimeoPlayer = (player, options) => new Player(player, options)

export {vimeoPlayer}
